import { GraduateCap, Handshake, IncomeGeneration, MagnifyingGlass } from "@/icons";

export const NOT_PARTICIPATED_STATUS = 'none';
export const NOT_COMPLETED_SURVEY_STATUS = 'registered';
export const COMPLETED_SURVEY_STATUS = 'jobs_profile_complete';

// We'll add more tags in future iterations
export const JOB_SEARCH = 'job-search';
export const WORKPLACE_SUCCESS = 'workplace-success';
export const CAREER_TRANSITIONS = 'career-transitions';
export const INCOME_GENERATION = 'income-generation';
export const JOBS_ARTICLES_TAGS = [
  JOB_SEARCH,
  WORKPLACE_SUCCESS,
  CAREER_TRANSITIONS,
  INCOME_GENERATION,
];

export const JOIN_JOBS_SURVEY_ID = 798;
export const JOBS_PROFILE_SURVEY_ID = 799;
export const JOBS_SURVEY_IDS = [JOIN_JOBS_SURVEY_ID, JOBS_PROFILE_SURVEY_ID];

export const JOBS_USER_LOCATION = 'jobs_user_location';

export const RESOURCES_CATEGORIES = [
  {
    category: 'job-search',
    href: '/jobs/resources/job-search',
    icon: MagnifyingGlass,
    titleOne: 'jobs.resources.job_search.title_one',
    titleTwo: 'jobs.resources.job_search.title_two',
    subtitle: 'jobs.resources.job_search.subtitle',
  },
  {
    category: 'workplace-success',
    href: '/jobs/resources/workplace-success',
    icon: Handshake,
    titleOne: 'jobs.resources.workplace_success.title_one',
    titleTwo: 'jobs.resources.workplace_success.title_two',
    subtitle: 'jobs.resources.workplace_success.subtitle',
  },
  {
    category: 'career-transitions',
    href: '/jobs/resources/career-transitions',
    icon: GraduateCap,
    titleOne: 'jobs.resources.career_transitions.title_one',
    titleTwo: 'jobs.resources.career_transitions.title_two',
    subtitle: 'jobs.resources.career_transitions.subtitle',
  },
  {
    category: 'income-generation',
    href: '/jobs/resources/income-generation',
    icon: IncomeGeneration,
    titleOne: 'jobs.resources.income_generation.title_one',
    titleTwo: 'jobs.resources.income_generation.title_two',
    subtitle: 'jobs.resources.income_generation.subtitle',
  },
];
